module.exports = __webpack_public_path__ + "img/head-box-background.90d4e5cd.png";